import { Component } from '@angular/core';
import { first } from 'rxjs/operators';


import { User } from '../_models/user';
import { UserService } from '../_services/user.service';
import { AuthenticationService } from '../_services/authentication.service';
import { Router } from '@angular/router';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {
  loading = false;
  currentUser: User = {
    organizationId: 1,
    role: ""
  };
  // userFromApi: User;

  constructor(private userService: UserService, public user: User, private authenticationService: AuthenticationService, private router: Router) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.logout();

  }
  logout() {
    this.user.role = "";
    this.user.accountOwnerId = null;
    this.user.userId = 0;
    this.user.adminUserId = 0;
    this.user.accountOwnerName = "";
    this.user.userName = "";
    this.user.organizationId = 0;
    this.user.token = null;
    this.router.navigate(['/access/login']);
  }


  ngOnInit() {
    this.loading = true;
    /*        this.userService.getById(this.currentUser.userId).pipe(first()).subscribe(user => {
                this.loading = false;
                this.userFromApi = user;
            });
    */
  }
}
